import { createFileRoute } from '@tanstack/react-router';

import { ProtectedRoute } from '@/components';
import DocumentMappingDashboard from '@/pages/DocumentMappingDashboard';

export const Route = createFileRoute('/config/document-mapping')({
  component: () => (
    <ProtectedRoute>
      <DocumentMappingDashboard />
    </ProtectedRoute>
  ),
});
